<div class="mt-video-chat" style="margin-top:60px;">
  <div class="mt-video-chat-header">
    <div class="mt-back-button" (click)="goBack()">
      <mitter-back-icon ></mitter-back-icon>
    </div>
  </div>

  <div class="mt-video-chat-content">
    <div id="mt-video-chat-remote" class="mt-video-remote"></div>

    <div id="mt-video-chat-self" class="mt-video-self"></div>
  </div>
</div>
